import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/primeng';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { QFilterModel } from '../../../models/qfilter.model';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { CustomerPointsCumulatedComponent } from './customer-points-cumulated/customer-points-cumulated.component';
import { CustomerPointsRedemptionComponent } from './customer-points-redemption/customer-points-redemption.component';

@Component({
  selector: 'app-customers-points',
  templateUrl: './customers-points.component.html',
  styleUrls: ['./customers-points.component.css']
})
export class CustomersPointsComponent implements OnInit {
  @ViewChild(CustomerPointsRedemptionComponent) redemptionPoints: CustomerPointsRedemptionComponent;
  @ViewChild(CustomerPointsCumulatedComponent) cumulatedPoints: CustomerPointsCumulatedComponent;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  items: MenuItem[];
  activeIndex: number;
  oldData: any;
  translations: any;

  selectedElapsedStart: Date = null;
  selectedElapsedEnd: Date = null;

  constructor(
    private ts: TranslateService,
    private svcAnalytics: AnalyticsService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {
    this.ts.get([
      'customer_chart.cumulated',
      'customer_chart.redemption',
    ]).subscribe(t => {

      this.translations = {
        cumulated: t['customer_chart.cumulated'],
        redemption: t['customer_chart.redemption'],
      };
      this.activeIndex = 0;
      this.items = [];

      this.items.push({
          label: this.translations.cumulated,
          command: (event: any) => {
            this.activeIndex = 0;
          }
        },
        {
          label: this.translations.redemption,
          command: (event: any) => {
            this.activeIndex = 1;
          }
        });

    });

    const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
    searchParams.svcAnalytics = this.svcAnalytics;
    searchParams.dateFunctionType = SearchToolbarDateFunction.SpDates;
    searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist];

    this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
      this.searchModel = model;
    });
  }

  dateStructureSelectionChange($event) {
    console.log('somethings', $event);
  }

  performFilter(data: QFilterModel) {

    const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

    if (this.activeIndex === 0) {
      if (!isDataEquals) {
        this.redemptionPoints.resetData();
      }
      this.cumulatedPoints.searchValueTrend(data);
    } else if (this.activeIndex === 1) {
      if (!isDataEquals) {
        this.cumulatedPoints.resetData();
      }

      this.redemptionPoints.searchValueTrend(data);
    }

    this.oldData = { ...data };
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-points/customers-points.component.ts